<template>
  <a-modal
    :visible="true"
    width="900px"
    centered
    :mask-closable="false"
    :body-style="{ padding: '12px 24px' }"
    :keyboard="false"
    @cancel="handleConfirmationClose"
  >
    <p>
      Selecciona qué tipo de datos deseas importar. Recuerda que éste depende de la
      <a @click="handleDownloadTemplate"> plantilla predefinida </a> que vayas a utilizar. Para
      asociar esta información a los datos de contacto o producto importados previamente, ambos
      deben contener los mismos códigos.

      <DownloadTemplate :value="downloadModal" @update:value="downloadModal = $event" />
    </p>

    <CustomScrollbar height="60vh" style="padding: 0 15px">
      <type-import-picker
        :value="importType"
        @update:value="importType = $event"
        :options="options.clientOptions"
        title="Importa más información para tus contactos:"
      />

      <type-import-picker
        :value="importType"
        @update:value="importType = $event"
        :options="options.otherOptions"
        title="Realiza otras acciones:"
        style="margin-top: 20px"
      />
    </CustomScrollbar>

    <!-- Title modal -->
    <template v-slot:title>
      <span class="modal__title">Procesos masivos</span>
      <a-tooltip>
        <template #title>
          <span> Importa grandes cantidades de datos de tus contactos </span>
        </template>
        <InfoCircleOutlined />
      </a-tooltip>
    </template>
    <!-- Fotter Modal -->
    <template v-slot:footer>
      <a-button key="back" @click="handleReturnModal"> Volver </a-button>
      <a-button key="submit" type="primary" :disabled="!importType" @click="handleOk">
        Continuar
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, createVNode } from "vue";
import { InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";

import { clientOptions, otherOptions } from "@/app/imports/utils/massiveProcess";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import DownloadTemplate from "@/app/imports/components/modals/modalImports/downloadTemplates/DownloadTemplate.vue";
import TypeImportPicker from "@/app/imports/components/pickers/TypeImportPicker.vue";

export default defineComponent({
  components: {
    DownloadTemplate,
    TypeImportPicker,
    InfoCircleOutlined,
    CustomScrollbar,
  },
  props: {
    modelValue: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      importType: 0,
      options: { clientOptions, otherOptions },
      downloadModal: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    visible(value) {
      if (value) this.importType = 0;
    },
  },
  methods: {
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    handleOk() {
      this.$emit("select:import", this.importType);
      this.$emit("onHideModalProcess");
    },
    handleDownloadTemplate() {
      this.downloadModal = true;
    },
    handleCancel() {
      this.$emit("onHideModalProcess");
    },
    handleReturnModal() {
      this.$emit("onReturnModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.modal
  &__title
    margin-right: 8px
</style>
